import { render, staticRenderFns } from "./imgListPdf.vue?vue&type=template&id=cff50faa&scoped=true"
import script from "./imgListPdf.vue?vue&type=script&lang=js"
export * from "./imgListPdf.vue?vue&type=script&lang=js"
import style0 from "./imgListPdf.vue?vue&type=style&index=0&id=cff50faa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff50faa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff50faa')) {
      api.createRecord('cff50faa', component.options)
    } else {
      api.reload('cff50faa', component.options)
    }
    module.hot.accept("./imgListPdf.vue?vue&type=template&id=cff50faa&scoped=true", function () {
      api.rerender('cff50faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/ImgList/imgListPdf.vue"
export default component.exports